import { render, staticRenderFns } from "./platformModal.vue?vue&type=template&id=75c824c8&scoped=true"
import script from "./platformModal.vue?vue&type=script&lang=js"
export * from "./platformModal.vue?vue&type=script&lang=js"
import style0 from "./platformModal.vue?vue&type=style&index=0&id=75c824c8&prod&lang=css"
import style1 from "./platformModal.vue?vue&type=style&index=1&id=75c824c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c824c8",
  null
  
)

export default component.exports